// extracted by mini-css-extract-plugin
export default {"content":"Breadcrumb_content__QlxQo","container":"Breadcrumb_container__XkSnm"};